import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StepEnum } from '../eform-steps.dto';

@Injectable({
  providedIn: 'root',
})
export class EformStepsService {
  public activeStepSubject = new BehaviorSubject<string>('active_role_field');
  activeStep$ = this.activeStepSubject.asObservable();

  setActiveStep(step: StepEnum) {
    this.activeStepSubject.next(step);
  }

  getActiveStep(): string {
    return this.activeStepSubject.getValue();
  }
}
